import { type PropsWithChildren, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../../auth/AuthContext';
import { useMembership } from '../../auth/MembershipContext';

export default function HomebrewAccess({ children }: PropsWithChildren) {
  const { isAuthenticated, isLoading, signIn } = useAuthContext();
  const { currentTenantAllowed } = useMembership();
  const location = useLocation();
  const started = useRef(false);
  useEffect(() => {
    if (isAuthenticated || isLoading || started.current) return;
    started.current = true;
    void signIn(`${location.pathname}${location.search}`);
  }, [isAuthenticated, isLoading, signIn, location.pathname, location.search]);
  if (!isAuthenticated)
    return (
      <p className="govuk-body" role="status">
        Signing you in...
      </p>
    );
  if (currentTenantAllowed === false) {
    return (
      <p className="govuk-body" role="alert">
        Your account does not have Homebrew access. Contact the team arranging your MacBook.
      </p>
    );
  }
  return <>{children}</>;
}
